<template>
  <b-form @submit.prevent="salvar">
    <b-alert :show="!!erro" variant="danger" role="alert">{{ erro }}</b-alert>
    <fieldset :disabled="ocupado">
      <b-row>
        <b-col md="3">
          <b-form-group
            label="UF do estabelecimento"
            label-for="econf-config-uf"
          >
            <b-form-select
              id="econf-config-uf"
              v-model="form.uf"
              :disabled="ufFixa"
              :options="ufs"
              @change="$emit('mudar-uf', form.uf)"
              required
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group
            label="Início da vigência"
            label-for="econf-config-inicio"
            description="Data de início da habilitação do ECONF para esta UF."
          >
            <b-form-input
              id="econf-config-inicio"
              v-model="form.inicio_vigencia"
              type="date"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-form-checkbox
        v-model="form.habilitado"
        switch
        class="mb-3"
        @change="alterarHabilitado"
        >Habilitar ECONF para esta UF</b-form-checkbox
      >
      <p class="text-muted">
        O envio é feito manualmente pelas ações de NF-e e NFC-e.
      </p>
      <b-form-checkbox
        v-model="form.obrigatorio"
        :disabled="!form.habilitado"
        class="mb-3"
        >Exigir ECONF conforme legislação aplicável ao
        estabelecimento</b-form-checkbox
      >
      <b-form-group
        v-if="form.obrigatorio"
        label="Fundamento legal"
        label-for="econf-fundamento"
      >
        <b-form-textarea
          id="econf-fundamento"
          v-model="form.fundamento_legal"
          rows="2"
          maxlength="500"
          required
          placeholder="Informe a norma estadual aplicável"
        />
      </b-form-group>
      <div class="d-flex justify-content-center mt-5">
        <b-button
          type="submit"
          variant="primary"
          class="font-weight-bold mr-2"
          :disabled="ocupado || !form.uf"
        >
          <b-spinner v-if="ocupado" small class="mr-2" />Salvar
        </b-button>
        <button
          type="button"
          class="btn btn-clean font-weight-bold"
          :disabled="ocupado"
          @click="$emit('cancelar')"
        >
          Cancelar
        </button>
      </div>
    </fieldset>
  </b-form>
</template>

<script>
import { configuracaoPadrao, UFS } from "@/modules/NFe/services/econf";

export default {
  name: "EconfConfiguracaoForm",
  props: {
    configuracao: { type: Object, default: () => configuracaoPadrao() },
    ocupado: Boolean,
    ufFixa: Boolean,
  },
  data() {
    return {
      form: configuracaoPadrao(),
      erro: "",
      ufs: [
        { value: "", text: "Selecione a UF" },
        ...UFS.map((uf) => ({ value: uf, text: uf })),
      ],
    };
  },
  watch: {
    configuracao: {
      immediate: true,
      deep: true,
      handler(valor) {
        this.form = { ...configuracaoPadrao(), ...valor };
        [
          "habilitado",
          "envio_automatico",
          "obrigatorio",
          "somente_posteriores",
        ].forEach((campo) => {
          this.form[campo] = [true, 1, "1"].includes(this.form[campo]);
        });
        this.erro = "";
      },
    },
  },
  methods: {
    alterarHabilitado(habilitado) {
      if (!habilitado) {
        this.form.envio_automatico = false;
        this.form.obrigatorio = false;
      }
    },
    salvar() {
      this.erro = "";
      if (!UFS.includes(this.form.uf) || !this.form.inicio_vigencia) {
        this.erro = "Informe a UF e o início da vigência.";
        return;
      }
      if (
        this.form.obrigatorio &&
        !String(this.form.fundamento_legal || "").trim()
      ) {
        this.erro = "Informe o fundamento legal para exigir o ECONF.";
        return;
      }
      const dados = configuracaoPadrao(this.form.uf);
      Object.keys(dados).forEach((campo) => {
        dados[campo] = this.form[campo];
      });
      dados.envio_automatico = false;
      dados.fundamento_legal =
        String(dados.fundamento_legal || "").trim() || null;
      this.$emit("salvar", dados);
    },
  },
};
</script>
